import axios from 'axios';
import { getUser, handleLogout } from 'src/utils/Common';
import { apiURL } from 'src/utils/config';
import { getToken, getTokenWs, getIpAddress } from './Common';
import { handleTransactionResponse } from './notificationManager';
import store from '../store/index';
import { generalActions } from 'src/store/slices/generalSlice';

const instance = axios.create({
  baseURL: `${apiURL}/Technician`
});
instance.interceptors.request.use(
  (config) => {
    const AuthToken = getToken();
    const AuthTokenWs = getTokenWs();
    const IpAddress = getIpAddress();
    const user = getUser();
    config.headers = {
      ...config.headers,
      Authorization: `Bearer ${AuthToken}`,
      SessionToken: AuthToken,
      SessionTokenWs: AuthTokenWs,
      IpAddress: IpAddress || '',
      'Auth-UserId': user ? user.UserId : '',
      'max-age': 86400,
      'X-Frame-Options': 'DENY',
      'X-XSS-Protection': '1;mode=block',
      Language: localStorage.getItem('i18nextLng')
    };
    return config;
  },
  (error) => Promise.reject(error)
);

instance.interceptors.response.use(
  async function (response) {
    return await handleTransactionResponse(response, store, generalActions);
  },
  (error) => {
    if (
      error.response
      && error.response.data
      && error.response.data.error === '401 Unauthorized'
    ) {
      alert(
        'Başka bir cihazdan giriş yaptığınız için oturumunuz sonlandırıldı!..'
      );
      handleLogout();
    }
    return Promise.reject(error);
  }
);

export default instance;
